import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button} from '@material-ui/core';
//import { makeStyles } from "@material-ui/core/styles";
import { LoadingButton } from '@mui/lab';
import SaveIcon from '@mui/icons-material/Save';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import {API_URL} from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

// const useStyles = makeStyles({
//   paper: {
//     fontSize: '12px !important',    
//   }
// });

var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {  
  var etlStudentObj = JSON.parse(localStorage.getItem('etlStudentObj'));
  const [open, setOpen] = React.useState(false); 
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");

  const [teacherLoginIdError, setTeacherLoginIdError] = React.useState(false);
  const [teacherLoginId, setTeacherLoginId] = React.useState("");
  const [submitLoading, setSubmitLoading] = React.useState(false);
  
  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}

  // function handleClassName(clsName){    
  //   if(clsName && props.classes.length>0){
  //     for(let i=0; i<props.classes.length; i++){
  //       if(props.classes[i].className===clsName){
  //         setCourseId(props.classes[i].courseId);
  //         setCourseTitle(props.classes[i].courseTitle);
  //         setOrganisationId(props.classes[i].organisationId);
  //         setClassName(props.classes[i].className);
  //       }
  //     }
  //   }
  // }


	function saveData(){

    if(!teacherLoginId || (teacherLoginId && teacherLoginId.length<1)){
        setSeverityAlert("error");
				setShowAlert(true);
				setAlertMessage("Enter teacher's user-id or email.");	
        setTeacherLoginIdError(true);
				return false;
    }

		if(teacherLoginId){ 
			let axiosHeader = {
				headers:{
          'Content-Type': 'multipart/mixed',
          'loginId': etlStudentObj.loginId,
          'token': etlStudentObj.token,
          'device': 'web'
        }
			}; 

      const data = new FormData(); 
      data.append('invitedTo', 'Teacher');
      data.append('invitedToUserId', teacherLoginId);
      data.append('actionById', etlStudentObj.loginId);
      
      setSubmitLoading(true);
			axios.post(API_URL+'/student-invite', data, axiosHeader)
			.then((response) => {
        setSubmitLoading(false);
				///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
          setSeverityAlert("success");
          setOpen(false);
					setShowAlert(true);
					setAlertMessage("Invitation has been sent successfully.");
					return false;

        }else if(response.data.responseTxt==="InvalidUserId"){
            setSeverityAlert("error");
            setShowAlert(true);
            setAlertMessage("Teacher detail is invalid.");
            return false;

        }else if(response.data.responseTxt==="AlreadyInvited"){
            setSeverityAlert("error");
            setShowAlert(true);
            setAlertMessage("You have already invited this teacher earlier");
            return false;

        }else if(response.data.responseTxt==="AlreadyRejected"){
            setSeverityAlert("error");
            setShowAlert(true);
            setAlertMessage("Teacher has rejected your request");
            return false;

        }else if(response.data.responseTxt==="AlreadyAccepted"){
            setSeverityAlert("success");
            setShowAlert(true);
            setAlertMessage("Teacher has already accepted your request");
            return false;
            
        }else if(response.data.responseTxt==="invalidToken"){
            window.localStorage.clear(); 
            window.location.href='logout';
        
				}else{
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Invitation could not be sent.");			
					return false;
				}
			})
			.catch((error) => {
				///console.log("AXIOS ERROR: ", error);
			})	
		}		
	}

  React.useEffect(() => {
    setTeacherLoginId("");

	}, [open]);
  
  return (
    <>
      <Dialog fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
          <DialogContent style={{height:250}}>
            <Grid item   md={12} xs={12} className="test-instructions" >
                  <div className="btmbdrgry"><h3>Invite Teacher</h3></div>
                  <p>
                            <TextField 
                              label="Teacher's User-Id or Email or Mobile"
                              onChange={event => setTeacherLoginId(event.target.value)} 
                              value={teacherLoginId} 
                              sx={{width:'99%',fontSize: 10}} 
                              variant="outlined"         
                              error={teacherLoginIdError}                     
                              />

                      <Box mt={2}>
                          <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button>
					    	          {submitLoading?
                            <LoadingButton loading={submitLoading} loadingPosition="start" startIcon={<SaveIcon />} style={{backgroundColor:'#ff1919',color:'#FFFFFF'}} variant="contained" >Wait</LoadingButton>
                          :<Button onClick={() => {saveData()}} size="small" variant="contained" style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} >Invite</Button>
                          }
                          
								      </Box>

                  </p>
            </Grid>
          </DialogContent>
      </Dialog>
      
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

    </>
  );

});

export default CustomizedDialogs;